import React from 'react'
import ReactDOM from 'react-dom'
import dva from 'dva'
import { BrowserRouter, StaticRouter, matchPath } from 'dva/router'
import Routes from './router'
import { createMemoryHistory, createBrowserHistory } from 'history'
import Models from './model'
import App from './App'
const env = process.env.NODE_ENV
const VERSION = __VERSION__

const clientRender = () => {
  const app = dva({ history: createBrowserHistory(),
    initialState: {
      moduleList: {
        data: window.__INITIAL_DATA__ || []
      }
    }
  })
  Models.forEach(item => {
    app.model(item)
  })

  app.router(() => (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  )
  )
  const Start = app.start()
  if (env === 'development' && module.hot) {
    module.hot.accept()
  }
  window.__VERSION__ = __VERSION__
  window._SSRERR_ ? ReactDOM.render(<Start />, document.getElementById('app')) : ReactDOM.hydrate(<Start />, document.getElementById('app'))
}

const serverRender = (ctx, serverData) => {
  const activeRoute = Routes.find((route) => matchPath(ctx.req.url, route)) || {}
  const promise = activeRoute.component && activeRoute.component.prefetch
    ? activeRoute.component.prefetch(ctx.req.url)
    : Promise.resolve()
  return promise.then(data => {
    const css = []
    const __INITIAL_DATA__ = serverData || data
    const context = {
      data: __INITIAL_DATA__
    }
    const history = createMemoryHistory({
      initialEntries: [ctx.req.url]
    })
    const serverApp = dva({ history,
      initialState: {
        moduleList: {
          data: __INITIAL_DATA__
        }
      }
    })
    Models.forEach(item => {
      serverApp.model(item)
    })
    serverApp.router(() => (
      <StaticRouter location={ctx.req.url} context={context}>
        <App />
      </StaticRouter>
    )
    )
    const start = serverApp.start()
    return {
      start,
      __INITIAL_DATA__,
      css,
      VERSION
    }
  })
}

export default __isBrowser__ ? clientRender() : serverRender
